import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private subject: BehaviorSubject<any> = new BehaviorSubject(null);;

  constructor(private router:Router) { }


  sendNotification(notificationType: any, notificationId: any) {
    this.subject.next({ notificationType: notificationType, notificationId: notificationId });
    if(notificationType && notificationId)
    this.router.navigate(['/dashboard'])
  }


  getNotification(): Observable<any> {
    return this.subject.asObservable();
  }
}
